// eslint-disable-next-line no-restricted-imports
import {
  OrderCommonDirectionEnum as IOrderDirectionEnum,
  OrderResponse as IOrderResponse,
  OrderResponseStateEnum as IOrderStateEnum,
} from '@eih-netbroker/api-order';
import { ListedInstrument } from '../instrument';
import { Ensure } from '../utils';

export type Order = Ensure<
  Omit<NonNullable<IOrderResponse>, 'isin' | 'mic'> & {
    instrument: ListedInstrument;
  },
  'tradingSession' | 'stopActivationPrice' | 'price' | 'visibleQty' | 'expiry' | 'inventoryManagementMethod'
>;

export const OrderStateEnum = IOrderStateEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderStateEnum = (typeof OrderStateEnum)[keyof typeof OrderStateEnum];

export const OrderDirectionEnum = IOrderDirectionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderDirectionEnum = (typeof IOrderDirectionEnum)[keyof typeof IOrderDirectionEnum];
